import { render, staticRenderFns } from "./address-books.vue?vue&type=template&id=af2b2990&"
import script from "./address-books.vue?vue&type=script&lang=js&"
export * from "./address-books.vue?vue&type=script&lang=js&"
import style0 from "./address-books.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports